<template>
  <Fragment>
    <template v-if="$route.name !== 'inquiryCodeIndex'">
      <router-view></router-view>
    </template>
    <section class="container" v-else>
      <Breadcrumb />
      <div class="card-wrap mt-20 mb-20">
        <section class="card-content">
          <div class="left">
            <div class="search-name mr-25">
              <span>请输入要查询的一维条码或二维码号：</span>
              <el-input v-model="ioidCode" width="500"> </el-input>
            </div>
            <el-button
              type="primary"
              class="ml-20"
              @click="searchInquiryCodeInfo"
              >查询</el-button
            >
            <el-button
              type="primary"
              class="mr-20"
              @click="downLoadInquiryCode()"
              >下载</el-button
            >
          </div>
        </section>
      </div>
      <br />
      <div>
        已绑定一维条码：<span>{{ total }}</span>
      </div>
      <el-table :data="list" style="width: 150%" border>
        <el-table-column label="序号" width="60">
          <template slot-scope="scope">
            <span>{{ scope.$index + (pageNum - 1) * pageSize + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column label="二维码号" width="270">
          <template slot-scope="scope">
            <span>{{ scope.row.ioidCode }}</span>
          </template>
        </el-table-column>
        <el-table-column label="码类型" width="80">
          <template slot-scope="scope">
            <span>{{ scope.row.typeName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="一维条码" width="250">
          <template slot-scope="scope">
            <span>{{ scope.row.barCode }}</span>
          </template>
        </el-table-column>
        <el-table-column label="售后人姓名" width="120">
          <template slot-scope="scope">
            <span>{{ scope.row.realName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="网点名称" width="150">
          <template slot-scope="scope">
            <span>{{ scope.row.networkName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="跳转路径">
          <template slot-scope="scope">
            <span>{{ scope.row.serviceUrl }}</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="mt-20 pagination"
        background
        layout="total,prev, pager, next, jumper"
        :total="total"
        :page-size="10"
        :current-page="pageNum"
        @prev-click="handlePrePage"
        @next-click="handleNextPage"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </section>
  </Fragment>
</template>

<script>
import { Fragment } from "vue-fragment";

import Breadcrumb from "@/components/Breadcrumb";
export default {
  name: "role",
  components: {
    Breadcrumb,
    Fragment
  },
  data() {
    return {
      labelPosition: "left",
      inquiryCodeInfo: {
        ioidCode: "",
        typeName: "",
        barCode: "",
        serviceUrl: ""
      },
      ioidCode: "",
      pmCount: "",
      list: [],
      pageNum: 1,
      pageSize: 10,
      total: 0
    };
  },
  methods: {
    getInquiryCodeList() {
      let _this = this;
      let param = {
        url: "/api/companyCode/getCompanyCodePage",
        params: {
          ioidCode: _this.ioidCode,
          pageNum: _this.pageNum,
          pageSize: _this.pageSize
        }
      };

      _this.$store.dispatch("getInquiryCodeList", param).then(() => {
        _this.list = _this.$store.state.inquiryCode.inquiryCodeList.list;
        _this.total = _this.$store.state.inquiryCode.inquiryCodeList.total;
      });
    },
    //查询
    searchInquiryCodeInfo() {
      let _this = this;
      _this.getInquiryCodeList();
    },
    //当前页
    handleCurrentChange(value) {
      let _this = this;
      _this.pageNum = value;
      _this.getInquiryCodeList();
    },
    //上一页
    handlePrePage() {
      let _this = this;
      _this.pageNum -= 1;
      _this.getInquiryCodeList();
    },
    //下一页
    handleNextPage() {
      let _this = this;
      _this.pageNum += 1;
      _this.getInquiryCodeList();
    },
    //根据二维码或一维码查询
    searchInquiryCodeByIOIDCode(value) {},
    //下载
    downLoadInquiryCode: function() {
      let _this = this;
      _this.$message({
        message: "功能尚未完成",
        type: "success"
      });
    }
  },
  created() {
    let _this = this;
    _this.getInquiryCodeList();
  }
};
</script>

<style lang="sass" scoped>
.card-wrap
  .card-content
    display: flex
    align-items: center
    justify-content: space-between
    .left
      display: flex
    .el-button
      font-size: 14px
    .search-name, .search-code
      font-size: 14px
      display: flex
      align-items: center
      span
        white-space: nowrap
.pagination
  text-align: center
</style>
